import React, {useEffect, useReducer, createContext, useMemo, useCallback} from 'react'
import {WizardNav, WizardBody} from './index'
import {useHistory, useLocation} from 'react-router-dom'
import {getOrderWizardForm} from '../_redux/wizardCrud'
import {KTWizard1} from '../../../../_metronic/_assets/js/components/wizard-1'
import {useSubheader} from '../../../../_metronic/layout'
import k1utils from '../../../../util/k1utils'
import {
  CHANGE_OPTION_DATA,
  CHANGE_OPTION_INPUT_DATA,
  CHANGE_OPTION_QUANTITY_DATA,
  CHANGE_SUB_OPTION_DATA,
  RESET_SUB_OPTION_DATA,
  SET_DATA,
  SET_DELIVERY_DATA,
  SET_MIN_AND_MAX_PRICE,
  SET_PRICE,
  SET_REFERENCE_CONTENTS,
  SET_REFERENCE_FILE,
  SET_SEARCH_STEP,
  SET_SELECT_CHECKBOX,
  WORK_TYPE_ORDER,
  WORK_TYPE_BOOKN,
} from '../WizardConstants'
import {
  wizardFormDelivery,
  wizardFormDeliveryAddress1,
  wizardFormDeliveryZipcode,
  wizardFormN,
  wizardFormY,
} from '../../../../util/Constants'

export const WizardContext = createContext({
  wizardForm: [],
  workTypeValue: '',
  dispatch: () => {},
})

const initialState = {
  store: undefined,
  calStep: undefined,
  form: undefined,
  wizardNav: undefined,
  wizardForm: undefined,
  keyData: undefined,
  imgFiles: [],
  imgList: [],
  step: undefined,
  workTypeValue: 'ORDER',
}

const reducer = (state, action) => {
  switch (action.type) {
    case SET_DATA:
      return {
        ...state,
        store: action.store,
        calStep: action.calStep,
        form: action.form,
        wizardNav: action.wizardNav,
        wizardForm: action.wizardForm,
        keyData: action.keyData,
        workTypeValue: action.workTypeValue,
      }
    case CHANGE_OPTION_DATA: {
      const keyData = {...state.keyData}
      const orderValue = keyData.order_value.find(
        (item) => item.t_order_item_name === action.dataName
      )
      orderValue.t_item_optionidx = parseInt(action.optionValue)
      orderValue.t_item_option_name = action.optionName
      orderValue.has_suboption = action.has_subOption
      orderValue.direct_text = ''
      orderValue.price_min = action.price_min
      orderValue.price_max = action.price_max
      return {
        ...state,
        keyData: keyData,
      }
    }
    case CHANGE_SUB_OPTION_DATA: {
      const keyData = {...state.keyData}
      const orderValue = keyData.order_value.find(
        (item) => item.t_item_option_name === action.dataName
      )
      orderValue.t_item_suboptionidx = parseInt(action.optionValue)
      orderValue.t_item_suboption_name = action.optionName
      orderValue.price_min = action.price_min
      orderValue.price_max = action.price_max
      return {
        ...state,
        keyData: keyData,
      }
    }
    case RESET_SUB_OPTION_DATA: {
      const keyData = {...state.keyData}
      const orderValue = keyData.order_value.find(
        (item) => item.t_order_item_name === action.dataName
      )
      orderValue.t_item_suboptionidx = parseInt(action.optionValue)
      orderValue.t_item_suboption_name = action.optionName
      orderValue.price_min = action.price_min
      orderValue.price_max = action.price_max

      return {
        ...state,
        keyData: keyData,
      }
    }
    case CHANGE_OPTION_INPUT_DATA: {
      const keyData = {...state.keyData}
      keyData.order_value.find((item) => item.t_order_item_name === action.dataName).direct_text =
        action.optionValue
      return {
        ...state,
        keyData: keyData,
      }
    }
    case CHANGE_OPTION_QUANTITY_DATA: {
      const keyData = {...state.keyData}
      keyData.quantity = action.optionValue
      keyData.order_value.find((item) => item.t_order_item_name === action.dataName).direct_text =
        action.optionValue
      return {
        ...state,
        keyData: keyData,
      }
    }
    case SET_DELIVERY_DATA: {
      const keyData = {...state.keyData}
      if (action.isPostCode) {
        keyData.order_delivery[wizardFormDeliveryZipcode] = action.zipcode
        keyData.order_delivery[wizardFormDeliveryAddress1] = action.address1
      } else {
        keyData.order_delivery[action.deliveryName] = action.deliveryValue
      }
      return {
        ...state,
        keyData: keyData,
      }
    }
    case SET_SELECT_CHECKBOX: {
      const keyData = {...state.keyData}
      if (action.name === wizardFormDelivery) {
        keyData.is_delivery = action.selected ? wizardFormY : wizardFormN
      }
      const selectOption = keyData.order_value.find(
        (item) => item.t_order_item_name === action.name
      )
      selectOption.is_checked = action.selected
      selectOption.price_min = action.price_min
      selectOption.price_max = action.price_max

      return {
        ...state,
        keyData: keyData,
      }
    }
    case SET_REFERENCE_CONTENTS: {
      const keyData = {...state.keyData}
      const refData = {...keyData.order_reference[0]}
      refData.contents = action.data
      keyData.order_reference[0] = refData
      return {
        ...state,
        keyData: keyData,
      }
    }
    case SET_REFERENCE_FILE: {
      return {
        ...state,
        imgFiles: action.imgFiles,
        imgList: action.imgList,
      }
    }
    case SET_PRICE: {
      const keyData = {...state.keyData}
      keyData.price = action.price
      return {
        ...state,
        keyData: keyData,
      }
    }
    case SET_MIN_AND_MAX_PRICE: {
      const keyData = {...state.keyData}
      let minPrice = 0,
        maxPrice = 0
      keyData.order_value.forEach((item) => {
        if (item.t_order_item_name !== wizardFormDelivery) {
          minPrice += item.price_min
          maxPrice += item.price_max
        }
      })
      keyData.price_min = minPrice
      keyData.price_max = maxPrice

      return {
        ...state,
        keyData: keyData,
      }
    }
    case SET_SEARCH_STEP: {
      return {
        ...state,
        step: action.step,
      }
    }
    default:
      return state
  }
}

const Wizard = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    store,
    calStep,
    form,
    wizardNav,
    wizardForm,
    keyData,
    imgFiles,
    imgList,
    step,
    workTypeValue,
  } = state

  const value = useMemo(
    () => ({
      store: store,
      calStep: calStep,
      form: form,
      wizardNav: wizardNav,
      wizardForm: wizardForm,
      keyData: keyData,
      imgFiles: imgFiles,
      imgList: imgList,
      step: step,
      workTypeValue: workTypeValue,
      dispatch,
    }),
    [store, calStep, form, wizardNav, wizardForm, keyData, imgFiles, imgList, step, workTypeValue]
  )

  //hooks -> location.state
  const location = useLocation()
  const order_key = location.pathname.split('/')[2]
  const formIdx = location.pathname.split('/')[3]

  const suhbeader = useSubheader()
  suhbeader.setTitle(`${store?.name} - ${form?.name}`)
  const history = useHistory()
  const search = location.search

  // console.log(location.search.substr(location.search.length-1, location.search.length))
  const fetchData = useCallback(async () => {
    const response = await getOrderWizardForm(order_key, formIdx)
    const result = response.data.data
    if (result.k1order_key.order_status === 5030) {
      history.push(`/k/${result.k1order_key.order_key}`)
      return false
    } else {
      const wizardData = []
      const calculateStep = 'CALCULATION_STEP'
      result.k1order_form2.items.forEach((item, i) => {
        const data = {id: i + 1, title: ''}
        item.forEach((title, idx, arr) => {
          data.title += arr.length - 1 !== idx ? `${title.name} / ` : `${title.name}`
        })
        wizardData.push(data)
      })
      let _workTypeValue =
        result.tstoreConf.find((conf) => conf.key === 'WORK_TYPE')?.value || 'ORDER'
      const typeName = _workTypeValue !== 'ORDER' ? WORK_TYPE_BOOKN : WORK_TYPE_ORDER

      wizardData.push({id: wizardData.length + 1, title: '디자인'})
      wizardData.push({id: wizardData.length + 1, title: typeName + '서 확인'})
      dispatch({
        type: SET_DATA,
        store: result.store,
        calStep: result.tstoreConf.find((conf) => conf.key === calculateStep)?.value,
        form: result.k1order_form2,
        wizardNav: wizardData,
        wizardForm: result.k1order_form2.items,
        keyData: result.k1order_key,
        workTypeValue: _workTypeValue,
      })

      const backgroundImageUrl = k1utils.toBigFileUrl(result.store.t_fileidx)
      document.getElementById('root').style.backgroundImage = `url(${backgroundImageUrl})`

      return result.k1order_form2.items.length
    }
  }, [formIdx, order_key, history])

  useEffect(() => {
    fetchData().then((res) => {
      if (res) {
        KTWizard1.init()
        if (search) {
          let step = parseInt(search.substr(search.length - 1, search.length))
          step = step > res ? res : step
          dispatch({type: SET_SEARCH_STEP, step: step})
        }
      }
    })
  }, [fetchData, dispatch, search])

  return (
    <WizardContext.Provider value={value}>
      <div className='card card-custom'>
        <div className='card-body p-0'>
          <div
            className='wizard wizard-1'
            id='kt_wizard'
            data-wizard-state='step-first'
            data-wizard-clickable='false'
          >
            {wizardNav && <WizardNav />}
            {wizardForm && <WizardBody />}
          </div>
        </div>
      </div>
    </WizardContext.Provider>
  )
}

export default Wizard
